import { combineReducers, Dispatch, Action, AnyAction } from "redux";
import { connectRouter, RouterState } from "connected-react-router";
import { all, fork } from "redux-saga/effects";
import { History } from "history";

// 公共模块
import { CommonState } from "./common/types";
import { commonReducer } from "./common/reducer";
import commonSaga from "./common/sagas";

import { AuthState } from "./auth/types";
import { authReducer } from "./auth/reducer";
import authSaga from "./auth/sagas";
/**。
 * 最上一级的state
 *
 * @export
 * @interface ApplicationState
 */
export interface ApplicationState {
  router: RouterState;
  commonState: CommonState;
  authState: AuthState
}

// 添加属性给react组件，此属性默认传递给connect()方法
export interface ConnectedReduxProps<A extends Action = AnyAction> {
  dispatch: Dispatch<A>
}

// 当action被调度, Redux根据名称去匹配reducer，然后更新相应的state
export const rootReducer = (history: History<any>) => combineReducers<ApplicationState>({
  router: connectRouter(history),
  commonState: commonReducer,
  authState: authReducer
});

// 合并saga
export function* rootSaga() {
  yield all([
    fork(commonSaga),
    fork(authSaga)
  ])
}
